import React from "react";
import styled from "styled-components";
import Data from "../../../_data";
import CartItemsList from "./components/cartItemsList";

const Cart = () => {
  const cartItems = Data.cart;

  let total = 0;
  cartItems.map((item) => {
    total += item.quantity * item.sellingPrice;
  });

  return (
    <CartContainer>
      <p className="title">Cart</p>
      <div className="seperator"></div>
      <CartItemsList itemsList={cartItems} />
      <div className="seperator"></div>
      <div className="details">
        <p className="total">{`Total : ${total}`}</p>
        <p className="note">Tax included and shipping calculated at checkout</p>
      </div>
      <div className="seperator"></div>
      <button className="checkout-btn">Checkout</button>
    </CartContainer>
  );
};

export default Cart;

const CartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px auto;
  width: 90vw;

  .checkout-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border: none;
    background: none;
    font-family: "Inter";
    background-color: #a3705f;
    border-radius: 7px;
    height: 40px;
    color: #f2e6e2;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
  }
  .note {
    text-align: center;
    font-size: 12px;
  }
  .seperator {
    border-bottom: 1px solid;
    width: 90vw;
    height: 2px;
    opacity: 30%;
  }

  .total {
    text-align: center;
    font-weight: 900;
  }

  .title {
    font-size: 25px;
    margin: 0;
    font-weight: 900;
  }
`;
